<template>
  <div class="search">
    <Dropdown class="search-menu" trigger="click" style="margin-left: 20px" @on-click="changeMenu">
      <a href="javascript:void(0)">
        <div>{{title}}</div>
        <Icon type="stats-bars" class="down"></Icon>
      </a>
      <Dropdown-menu class="menu-item" slot="list">
        <Dropdown-item v-for="(value,index) in items" :name="index" :key="index">{{value}}</Dropdown-item>
      </Dropdown-menu>
    </Dropdown>
    <div class="input-box">
      <img src="../assets/icon_search.png" />
      <!-- <form action="" class=""> -->
      <input type="search" v-model="keyword" placeholder="请输入关键字" v-on:keyup.13="searchClick" />
      <!-- </form> -->
    </div>
    <div class="buy-cart" @click="cartClick"></div>
  </div>
</template>

<script>
import { Toast } from 'mint-ui'
export default {
  data () {
    return {
      theme1: 'light',
      items: ['搜产品', '搜采购', '搜供应商', '搜百科'],
      title: '搜产品',
      keyIndex: 0,
      keyword: ''
    }
  },
  methods: {
    changeMenu: function (key) {
      this.keyIndex = key
      this.title = this.items[key]
    },
    searchClick () {
      // console.log(this.keyIndex)
      // console.log(this.keyword)
      let str = this.keyword.replace(/^\s\s*/, '').replace(/^\s\s*/, '')
      if (str.length <= 0 || str === '') {
        Toast('请输入关键字')
        return
      }
      const regex = '^[\u4E00-\u9FA50-9a-zA-Z]+$'
      if (!str.match(regex)) {
        Toast('只能输入中文、英文、数字')
        return
      }
      if (this.keyIndex === 0) {
        this.$router.push({
          path: '/homePage/goodslist',
          query: {
            key: this.keyword,
            shopState: 1
          }
        })
      }
      if (this.keyIndex === 1) {
        this.$router.push({
          path: '/homePage/goodslist',
          query: {
            key: this.keyword,
            shopState: 2
          }
        })
        // window.location.href = 'https://m.zxzx119.com/homePage/goodslist?key=' + this.keyword
      }
      if (this.keyIndex === 2) {
        window.location.href = 'http://www.zxzx119.com/ListEnterprises?key=' + this.keyword
      }
      if (this.keyIndex === 3) {
        window.location.href = 'http://www.zxzx119.com/wiki?key=' + this.keyword
      }
      //  else {
      //   if (this.keyIndex === 0) {
      //     window.location.href = 'https://m.zxzx119.com/homePage/goodslist?key=' + this.keyword
      //   }
      //   if (this.keyIndex === 1) {
      //     window.location.href = 'https://m.zxzx119.com/homePage/goodslist?key=' + this.keyword
      //   }
      //   if (this.keyIndex === 2) {
      //     window.location.href = 'http://www.zxzx119.com/ListEnterprises?key=' + this.keyword
      //   }
      //   if (this.keyIndex === 3) {
      //     window.location.href = 'http://www.zxzx119.com/wiki?key=' + this.keyword
      //   }
      // }
    },
    cartClick: function () {
      // 购物车
      this.$router.push({
        path: '/homePage/shoppingCart?isTab=1'
      })
    }
  }
}
</script>

<style scoped>
.search {
  position: relative;
  height: 50px;
  background-color: #ffffff;
  border-bottom: #e0e0e0 solid 1px;
}
.search .search-menu {
  position: absolute;
  left: -5px;
  height: 48px;
  line-height: 48px;
}
.search .search-menu a {
  position: absolute;
  left: -5px;
  /*top: 50px;*/
  width: 60px;
  color: #000000;
  font-size: 13px;
  text-align: center;
}
.search .search-menu a .down {
  position: absolute;
  top: 22px;
  right: -8px;
  width: 7px;
  height: 4px;
  background-image: url(../assets/icon-down.png);
  background-size: cover;
  background-position: center center;
  /*background-color: purple;*/
}
.search .search-menu .menu-item {
  /*padding-top: 50px;*/
  position: absolute;
  top: 50px;
  width: 50px;
  min-width: 90px;
  left: -10px;
  color: #999999;
  font-size: 13px;
  background-color: #ffffff;
  border-radius: 2px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.2);
}
.search .input-box {
  position: absolute;
  top: 8px;
  left: 90px;
  width: calc(100% - 140px);
  height: 35px;
  z-index: 100;
  border: solid #eaeaea 1px;
  box-sizing: border-box;
  border-radius: 18px;
}
.input-box img {
  position: absolute;
  top: 8px;
  left: 8px;
  width: 15px;
  height: 15px;
}
.input-box input {
  border: none;
  box-sizing: border-box;
  position: absolute;
  top: 0px;
  left: 30px;
  width: calc(100% - 40px);
  height: 32px;
}
.search .buy-cart {
  position: absolute;
  top: 15px;
  right: 15px;
  width: 20px;
  height: 20px;
  background-image: url(../assets/icon_cart.png);
  background-size: cover;
  background-position: center center;
  z-index: 100;
}
</style>



// WEBPACK FOOTER //
// src/view/search.vue